import { useState, useEffect } from 'react'
import { Menu, X } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { Link } from 'react-router-dom'

const navItems = [
  { label: 'Início', href: '#hero' },
  { label: 'O que fazemos', href: '#services' },
  { label: 'Como funciona', href: '#process' },
  { label: 'Diferenciais', href: '#differentials' },
  { label: 'Consultar CEP', href: '#cep-checker', primary: true },
  { label: 'Contato', href: '#contact' },
]

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const scrollToSection = (id: string) => {
    setIsMobileMenuOpen(false)
    const element = document.querySelector(id)
    if (element) {
      const offset = 80
      const elementPosition = element.getBoundingClientRect().top
      const offsetPosition = elementPosition + window.pageYOffset - offset

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      })
    }
  }

  return (
    <header
      className={cn(
        'sticky top-0 z-50 w-full transition-all duration-300',
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-sm py-2'
          : 'bg-transparent py-4',
      )}
    >
      <div className="container mx-auto px-4 flex items-center justify-between">
        {/* Logo Area */}
        <Link
          to="/"
          className="flex items-center gap-2"
          onClick={() => scrollToSection('#hero')}
          aria-label="Transbio Home"
        >
          <div className="flex items-center gap-2">
            <img
              src="https://lh3.googleusercontent.com/d/11qfTcyfnVltxzRDy1iALp4ZnMJpL8k9r"
              alt="Transbio Logo"
              className="h-[52px] md:h-[62px] w-auto object-contain"
            />
          </div>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((item) =>
            item.primary ? null : (
              <button
                key={item.label}
                onClick={() => scrollToSection(item.href)}
                className={cn(
                  'text-sm font-medium transition-colors hover:text-primary',
                  isScrolled ? 'text-foreground' : 'text-gray-800',
                )}
              >
                {item.label}
              </button>
            ),
          )}
          <Button
            onClick={() => scrollToSection('#cep-checker')}
            className="bg-primary hover:bg-primary/90 text-white shadow-md hover:shadow-lg transition-all animate-pulse-green"
          >
            Solicitar Orçamento
          </Button>
        </nav>

        {/* Mobile Toggle */}
        <button
          className="md:hidden p-2 text-foreground"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? (
            <X className="h-6 w-6" />
          ) : (
            <Menu className="h-6 w-6" />
          )}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="absolute top-full left-0 w-full bg-white shadow-lg border-t md:hidden animate-fade-in-down">
          <div className="flex flex-col p-4 space-y-4">
            {navItems.map((item) => (
              <button
                key={item.label}
                onClick={() => scrollToSection(item.href)}
                className={cn(
                  'text-left text-lg font-medium py-2 border-b border-gray-100 last:border-0',
                  item.primary ? 'text-primary font-bold' : 'text-foreground',
                )}
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </header>
  )
}
